import React, { useEffect, useState, useRef, } from 'react'
import Loader from '../components/Loader';

import $ from 'jquery';
import 'select2/dist/css/select2.min.css';
import 'select2';
import { registration, editUser, getUserDataByID } from '../api/user';
import { companyDataByID } from '../api/company';
import { getInquiryDataByID } from "../api/userInquiry"
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import PopupModal from '../components/PopupModal';
import useUserStore from '../store/useUserStore';

const SCOPE_OPTIONS = [
    { value: 'write:customs-declaration', label: 'customs-declaration' },
    { value: 'write:customs-declarations-information', label: 'customs-declarations-information' },
    { value: 'write:customs-inventory-linking-exports', label: 'customs-inventory-linking-exports' },
    { value: 'write:goods-movement-system', label: 'goods-movement-system' },
    { value: 'write:import-control-system-2', label: 'Import Control System 2' },
    { value: 'common-transit-convention-traders', label: 'common transit convention traders' },
    { value: 'common-transit-convention-guarantee-balance', label: 'guarantee balance' },
    { value: 'write:import-control-system', label: 'import control system' },
    { value: 'read:vat', label: 'Read VAT' },
    { value: 'write:vat', label: 'Write VAT' }
];

const ALL_SCOPES = SCOPE_OPTIONS.map((opt) => opt.value).join('+');

const isBlankUid = (uid) => uid == null || uid === '';

const REGISTRATION_COPY_FIELDS = [
    'DecEORINumber',
    'DecName',
    'DecAddress',
    'DecCity',
    'DecPostalCode',
    'DecCountry',
    'DecEmail',
    'swprID',
    'FullName',
    'email',
    'tdremail',
    'Address',
    'phoneno',
    'uType',
    'password',
    'nextSystemUser',
    'clientID',
    'scope',
    'recordlistdaterange',
];

const copiedRegistrationFields = (copiedUser) => {
    if (!copiedUser || typeof copiedUser !== 'object') return null;
    const next = {};
    for (const key of REGISTRATION_COPY_FIELDS) {
        if (copiedUser[key] != null && copiedUser[key] !== '') {
            next[key] = copiedUser[key];
        }
    }
    return Object.keys(next).length ? next : null;
};

export default function UserRegistration() {

    const { cid, mm, uid } = useParams();
    const location = useLocation();
    const { user } = useUserStore();

    const navigate = useNavigate();

    const selectRef = useRef();
    const [showPopup, setShowPopup] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState({ "title": "", "text": "" })
    // const [selectedOptions, setSelectedOptions] = useState([]);

    const [loading, setLoading] = useState(false);

    let formInput = {
        DecEORINumber: '',
        _id: "",
        DecName: "",
        DecAddress: "",
        recordlistdaterange: "",
        scope: isBlankUid(uid) ? ALL_SCOPES : "",
        DecCity: "",
        DecPostalCode: "",
        DecCountry: "GB",
        DecEmail: "",
        swprID: "",
        FullName: "",
        email: "",
        tdremail: "",
        Address: "",
        phoneno: "",
        uType: "",
        password: "Welcome1",
        nextSystemUser: "",
        clientID: "",
    };
    const copiedFields = copiedRegistrationFields(location.state?.copiedUser);
    if (copiedFields) {
        formInput = { ...formInput, ...copiedFields };
    }
    let [formData, setFormData] = useState(formInput);

    useEffect(() => {

        const getUserData = async (id) => {
            const userData = await getUserDataByID(id);
            if (userData.status >= 199 && userData.status <= 399) {
                const userDataS = userData.data.data;

                setFormData({
                    ...formData,
                    DecEORINumber: userDataS?.Role_FreightForwarder?.DecEORINumber,
                    DecName: userDataS?.Role_FreightForwarder?.DecName,
                    DecAddress: userDataS?.Role_FreightForwarder?.DecAddress,
                    DecCity: userDataS?.Role_FreightForwarder?.DecCity,
                    DecPostalCode: userDataS?.Role_FreightForwarder?.DecPostalCode,
                    DecCountry: userDataS?.Role_FreightForwarder?.DecCountry,
                    DecEmail: userDataS?.Role_FreightForwarder?.DecEmail,
                    swprID: userDataS?.swprID || "",
                    FullName: userDataS?.name,
                    email: userDataS?.email,
                    uType: userDataS?.uType,
                    clientID: userDataS?.clientID,
                    Address: userDataS?.Address,
                    phoneno: userDataS?.phoneno,
                    scope: userDataS?.scope,
                    recordlistdaterange: userDataS.recordlistdaterange,
                    nextSystemUser: (user.db.toLowerCase() == "tdr" ? userDataS?.nextSystemUser : userDataS.preSystemUser)
                })
            }
        }
        if (uid != null && uid !== undefined) {
            getUserData(uid);
        }
    }, [uid])
    useEffect(() => {
        const getCompanyData = async () => {
            setLoading(true);

            if (mm !== undefined) {
                let response = await getInquiryDataByID(cid);
                setLoading(false);
                if (response.status >= 199 && response.status <= 399) {
                    setFormData((prev) => ({
                        ...prev,
                        _id: response.data.data._id,
                        DecName: response.data.data.company,
                        Phone: response.data.data.phone,
                        phoneno: response.data.data.phone,
                        email: response.data.data.email,
                        Address: response.data.data.address,
                        DecEORINumber: response.data.data.eoriNumber,
                        DecCity: response.data.data.city,
                        DecPostalCode: response.data.data.postcode,
                        uType: response.data.data.traderOrAgent,
                        FullName: `${response.data.data.firstName} ${response.data.data.lastName}`
                    }));
                }
            } else {
                let response = await companyDataByID(cid);
                setLoading(false);
                if (response.status >= 199 && response.status <= 399) {
                    setFormData((prev) => ({
                        ...prev,
                        DecName: response.data.data.companyName,
                        Phone: response.data.data.Phone,
                        email: response.data.data.email,
                        Address: response.data.data.address,
                    }));
                }
            }

        }
        if (cid !== undefined) {
            getCompanyData();
        }

    }, [cid]);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = `${process.env.PUBLIC_URL}/assets/js/misc.js`; // e.g., '/scripts/some-lib.js'
        script.async = true;
        // script.id = 'dynamic-js';

        document.body.appendChild(script);

        // Optional cleanup: remove script on component unmount
        return () => {
            // document.getElementById('dynamic-js')?.remove();
        };
    }, []);

    const [userType, setUserType] = useState([]);
    const [incotermLocation, setIncotermLocation] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState([]);
    const [incoterm, setIncoterm] = useState([]);
    const [recordListDateRange, setRecordListDateRange] = useState([]);

    const mapArray = {
        "uType": userType,
        "cnsPaymentMethod1": paymentMethod,
        "cnsIncoTermLocation": incotermLocation,
        "cnsIncoTerm": incoterm,
    }

    const [scopeOptions] = useState(SCOPE_OPTIONS);

    useEffect(() => {
        const $select = $(selectRef.current);

        // Convert scope string into array of selected values
        const selected = formData.scope ? formData.scope.split('+') : [];

        $select.val(selected).trigger('change'); // Set selected values


        $select.select2();
        $select.on('change', function (e) {

            const name = e.target.name;
            const selectedValues = $(this).val(); // array of selected values
            let selectedData = scopeOptions.filter(opt => selectedValues.includes(opt.value));

            const result = selectedData.map(item => item.value).join('+');

            if (result === "") {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: '',
                }));
                setFormData((prev) => ({
                    ...prev,
                    [name]: ""
                }));
            } else {
                setFormData((prev) => ({
                    ...prev,
                    [name]: result
                }));

                if (errors[name]) {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        [name]: '',
                    }));
                }
            }
        });
        return () => {
            $select.select2('destroy');
        };
    }, [formData.scope]);

    useEffect(() => {
        setRecordListDateRange([
            {
                "key": "",
                "value": "Select Date Range"
            },
            {
                "key": "currentYear",
                "value": "Current Year"
            },
            {
                "key": "1Week",
                "value": "1 Week"
            },
            {
                "key": "4Weeks",
                "value": "4 Week"
            },
            {
                "key": "1Month",
                "value": "1 Month"
            },
            {
                "key": "6Weeks",
                "value": "6 Weeks"
            },
            {
                "key": "2Month",
                "value": "2 Month"
            },
            {
                "key": "3Month",
                "value": "3 Month"
            },
            {
                "key": "4Month",
                "value": "4 Month"
            },
            {
                "key": "5Month",
                "value": "5 Month"
            },
            {
                "key": "6Month",
                "value": "6 Month"
            },
            {
                "key": "9Month",
                "value": "9 Month"
            },
            {
                "key": "1Year",
                "value": "1 Year"
            },
            {
                "key": "2Year",
                "value": "2 Year"
            },
            {
                "key": "3Year",
                "value": "3 Year"
            },
            {
                "key": "5Year",
                "value": "5 Year"
            },
            {
                "key": "7Year",
                "value": "7 Year"
            },
        ])
        setIncotermLocation([
            {
                "key": "",
                "value": "Select IncoTerm Location"
            },
            {
                "key": "GBLHR",
                "value": "LHR - Heathrow Apt/London"
            }
        ])
        setPaymentMethod([
            {
                "key": "",
                "value": "Select Payment Method"
            },
            {
                "key": "P",
                "value": "P - Immediate payment from CDS Cash Account"
            }
        ])
        setIncoterm([
            {
                "key": "",
                "value": "Select IncoTerm"
            },
            {
                "key": "DAT",
                "value": "DAT - Deliver At Terminal"
            }
        ])
        setUserType([
            {
                "key": "",
                "value": "Select User Type"
            },
            {
                "key": "Agent",
                "value": "Agent"
            },
            {
                "key": "Carrier",
                "value": "Carrier"
            },
            {
                "key": "Trader",
                "value": "Trader"
            }
        ])
    }, []);
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");


    const handleChange = (e) => {

        const { name, value } = e.target;
        if (name in mapArray) {
            if (value === "") {
                setFormData((prev) => ({
                    ...prev,
                    [`${name}_key`]: "",
                    [`${name}`]: "",
                }));

            } else {
                const result = mapArray[name].find(item => item.key === value);
                setFormData((prev) => ({
                    ...prev,
                    [`${name}_key`]: result.key,
                    [`${name}`]: result.value,
                }));
            }

        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

        // Clear error for the field being typed
        if (errors[name]) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: '',
            }));
        }

    };

    const validate = () => {
        const newErrors = {};
        if (!formData.DecEORINumber) newErrors.DecEORINumber = 'Dec EORI Number is required';
        if (!formData.DecName) newErrors.DecName = 'Dec Name is required';
        if (!formData.DecAddress) newErrors.DecAddress = 'Dec Address is required';
        if (!formData.DecCity) newErrors.DecCity = 'Dec City is required';
        if (!formData.DecPostalCode) newErrors.DecPostalCode = 'Dec Postal code is required';
        if (!formData.DecCountry) newErrors.DecCountry = 'Dec Country is required';
        if (!formData.DecEmail) newErrors.DecEmail = 'Dec Email is required';
        if (!formData.FullName) newErrors.FullName = 'Full name is required';
        if (!formData.email) newErrors.email = 'Email is required';
        // if (!formData.Address) newErrors.Address = 'Address is required';
        if (!formData.uType) newErrors.uType = 'User Type is required';
        if (!formData.password) newErrors.password = 'Password is required';
        if (!formData.nextSystemUser) newErrors.nextSystemUser = 'Next system email is required';
        if (!formData.recordlistdaterange) newErrors.recordlistdaterange = 'Record date range  is required';

        // Client ID validation: required, min 3, max 6 characters
        if (!formData.clientID) {
            newErrors.clientID = 'Client ID is required';
        } else if (formData.clientID.length < 3) {
            newErrors.clientID = 'Client ID must be at least 3 characters';
        } else if (formData.clientID.length > 6) {
            newErrors.clientID = 'Client ID cannot exceed 6 characters';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleRegistration = async (e) => {
        e.preventDefault();

        if (!validate()) {
            setApiError("Please add required fields")
            setErrorStatus('danger')
            return;
        }

        try {
            setLoading(true);
            let response = "";
            if (uid !== null && uid !== undefined) {
                response = await editUser(formData, uid);
            } else {

                if (cid !== null && cid !== undefined) {
                    formData = {
                        ...formData,
                        addUserInCompany: true
                    }
                }
                let dbList = [];
                if (user.db === "tdr") {
                    // dbList = ["tdr", "pro"]
                    dbList = ["tdr"]
                } else {
                    dbList = ["pro"]
                }
                formData = {
                    ...formData,
                    systemList: dbList
                }
                response = await registration(formData);
            }

            if (uid !== null && uid !== undefined) {
                setPopUpMessage({
                    "title": "Success",
                    "text": response.data?.message || "User Updated Successfully..."
                });
                setShowPopup(true);
            } else {

                if (response.status > 199 && response.status < 400) {
                    setPopUpMessage({
                        "title": (response.data.data[0].success) ? "Success" : "Error",
                        "text": response.data.data[0].message
                    });
                    setShowPopup(true);
                    // (response.data.data[0].success) ? setFormData(formInput) : ""
                } else {
                    setPopUpMessage({
                        "title": "Error",
                        "text": response.data.message
                    });
                    setShowPopup(true);
                }
            }


        } catch (error) {

            const message = error?.data?.message || error?.statusText || 'Login failed';
            setApiError(message);
            setTimeout(() => {
                setApiError(null);
                setErrorStatus('danger')

            }, 5000);
        } finally {
            setLoading(false);
        }
    };
    const handleGotoCompany = async () => {
        navigate(`/company`)
    }
    const copyUserInfoToDec = async () => {
        if (uid === null || uid === undefined) {
            setFormData({
                ...formData,
                DecName: formData.FullName,
                DecAddress: formData.Address,
                DecEmail: formData.email
            })
        } else {
            setShowPopup(true);
            setPopUpMessage({
                "title": "Alert",
                "text": "During edit, user information cannot be copied to the declarant section. Please update the details manually."
            })

        }

    }

    return (
        <>
            {loading && <Loader />}
            <PopupModal
                isOpen={showPopup}
                data={popUpMessage}
                onClose={() => {
                    setShowPopup(false)
                    setPopUpMessage({
                        "title": "",
                        "text": ""
                    })
                }}
            />


            <form onSubmit={handleRegistration}>
                <div className="content-wrapper">
                    <div className="page-header">
                        <h3 className="page-title"> User Registration </h3>
                        {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}

                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <button type="submit" className="btn btn-primary me-2">{uid === null || uid === undefined ? "Save" : "Save"}</button>
                                {uid !== null && uid !== undefined &&
                                    <button type="button" onClick={handleGotoCompany} className="btn btn-success me-2"> Company List</button>
                                }

                            </ol>
                        </nav>
                    </div>
                    <div className="row">

                        <div className="col-md-4 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title">Declarant Information</h4>
                                    {/* <p className="card-description"> Basic form layout </p> */}

                                    <div className="form-group">
                                        <label >Dec EORI Number</label>
                                        <input
                                            type="text"
                                            className="form-control"

                                            name="DecEORINumber"
                                            value={formData.DecEORINumber}
                                            onChange={handleChange}
                                            placeholder="Dec EORI Number" />
                                        {errors.DecEORINumber && <span className="text-danger">{errors.DecEORINumber}</span>}
                                    </div>

                                    <button type="button" style={{ marginBottom: 20 }} onClick={copyUserInfoToDec} className="btn btn-primary me-2">Copy from User Information</button>


                                    <div className="form-group">
                                        <label >Dec Name</label>
                                        <input
                                            readOnly={uid !== null}
                                            type="text"
                                            className="form-control"
                                            name="DecName"
                                            value={formData.DecName}
                                            onChange={handleChange}
                                            placeholder="Dec Name" />
                                        {errors.DecName && <span className="text-danger">{errors.DecName}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label >Dec Address</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="DecAddress"
                                            value={formData.DecAddress}
                                            onChange={handleChange}
                                            placeholder="Dec Address" />
                                        {errors.DecAddress && <span className="text-danger">{errors.DecAddress}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label >Dec City</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="DecCity"
                                            value={formData.DecCity}
                                            onChange={handleChange}
                                            placeholder="Dec City" />
                                        {errors.DecCity && <span className="text-danger">{errors.DecCity}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label >Dec PostalCode</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="DecPostalCode"
                                            value={formData.DecPostalCode}
                                            onChange={handleChange}
                                            placeholder="Dec PostalCode" />
                                        {errors.DecPostalCode && <span className="text-danger">{errors.DecPostalCode}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label >Dec Country</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="DecCountry"
                                            value={formData.DecCountry}
                                            onChange={handleChange}
                                            placeholder="Dec Country" />
                                        {errors.DecCountry && <span className="text-danger">{errors.DecCountry}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label >Dec Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="DecEmail"
                                            value={formData.DecEmail}
                                            onChange={handleChange}
                                            placeholder="Dec Email" />
                                        {errors.DecEmail && <span className="text-danger">{errors.DecEmail}</span>}
                                    </div>

                                    <div className="form-group">
                                        <label >SWPR ID</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="swprID"
                                            value={formData.swprID}
                                            onChange={handleChange}
                                            placeholder="SWPR ID" />

                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title">User Information</h4>
                                    {/* <p className="card-description"> Basic form layout </p> */}

                                    <div className="form-group">
                                        <label >Full Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="FullName"
                                            value={formData.FullName}
                                            onChange={handleChange}
                                            placeholder="Full Name" />
                                        {errors.FullName && <span className="text-danger">{errors.FullName}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label >Email</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder="Email" />
                                        {errors.email && <span className="text-danger">{errors.email}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label >Address</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="Address"
                                            value={formData.Address}
                                            onChange={handleChange}
                                            placeholder="Address" />
                                        {errors.Address && <span className="text-danger">{errors.Address}</span>}
                                    </div>

                                    <div className="form-group">
                                        <label >Phone Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="phoneno"
                                            value={formData.phoneno}
                                            onChange={handleChange}
                                            placeholder="phoneno" />
                                        {errors.phoneno && <span className="text-danger">{errors.phoneno}</span>}
                                    </div>


                                    <div className="form-group">
                                        <label >User Type</label>
                                        <select className="form-select" name="uType" value={formData.uType} onChange={handleChange} >
                                            {userType.map((obj) => (
                                                <option key={obj.key} value={obj.key}>{obj.value}</option>
                                            ))}
                                        </select>
                                        {errors.uType && <span className="text-danger">{errors.uType}</span>}
                                    </div>

                                    <div className="form-group">
                                        <label>Scope</label>

                                        <select
                                            ref={selectRef}
                                            name="scope"
                                            className="js-example-basic-multiple"
                                            multiple
                                            style={{ width: '100%' }}
                                        >
                                            {scopeOptions.map((opt) => (
                                                <option key={opt.value} value={opt.value}>
                                                    {opt.label}
                                                </option>
                                            ))}
                                        </select>

                                        {errors.scope && <span className="text-danger">{errors.scope}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label >Password</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            placeholder="Password" />
                                        {errors.password && <span className="text-danger">{errors.password}</span>}
                                    </div>

                                    <div className="form-group">
                                        <label >Next System User</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="nextSystemUser"
                                            value={formData.nextSystemUser}
                                            onChange={handleChange}
                                            placeholder="Next System User" />
                                        {errors.nextSystemUser && <span className="text-danger">{errors.nextSystemUser}</span>}
                                    </div>

                                    <div className="form-group">
                                        <label>Client ID</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Client ID"
                                            name="clientID"
                                            value={formData.clientID}
                                            onChange={handleChange}
                                            aria-label="Username" />
                                        {errors.clientID && <span className="text-danger">{errors.clientID}</span>}
                                    </div>

                                    <div className="form-group">
                                        <label >Record List Date Range</label>
                                        <select className="form-select" name="recordlistdaterange" value={formData.recordlistdaterange} onChange={handleChange} >
                                            {recordListDateRange.map((obj) => (
                                                <option key={obj.key} value={obj.key}>{obj.value}</option>
                                            ))}

                                        </select>
                                        {errors.recordlistdaterange && <span className="text-danger">{errors.recordlistdaterange}</span>}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>

    )
}
